/* ZINKE — Newsletter-Pop-up „Willkommen", 18.09.2026 (Theme 2.4)
   Beschreibung und Regeln: snippets/zinke-newsletter.liquid

   GEÄNDERT 22.09.2026 — Code kommt NUR NOCH PER MAIL
   --------------------------------------------------
   Anlass: In der Nacht auf den 22.09. legte jemand mit
   max.mustermann@example.com vier Checkouts an. Der Code stand bis dahin
   sofort im Dankschritt und wurde automatisch in den Warenkorb gelegt — eine
   Fantasieadresse reichte also, um ihn zu bekommen.

   Jetzt:
   - codeHinterlegen() ist entfernt. Es wird KEIN /discount/… mehr aufgerufen,
     der Code landet nicht mehr von selbst im Warenkorb.
   - Der Kopierknopf ist weg, weil der Code im Dankschritt nicht mehr steht.
   - Die Adressprüfung ist deutlich strenger: Beispiel- und Testdomains,
     gesperrte TLDs und offensichtliche Fantasienamen werden abgewiesen.
   - Der Code kommt aus der Willkommens-Automatisierung in Shopify Marketing.
     Ist die nicht eingerichtet, bekommt niemand einen Code.

   GEÄNDERT 18.09.2026 abends (Theme 2.5) — wann das Angebot erscheint
   ------------------------------------------------------------------
   Vorher: nach 20 Sekunden ein Fenster über den ganzen Bildschirm, auf allen
   Geräten. Auswertung derselben Woche: die Anzeigenbesucher (Handy) waren
   nach einer Seite weg und haben es nie gesehen; wer blieb, wurde beim Lesen
   der Produktseite unterbrochen.

   Jetzt:
   - HANDY (bis 749 px): nach LEISTE_SEKUNDEN sichtbarer Zeit eine schmale
     Leiste unten („5 % auf deine erste Bestellung · Code sichern“). Sie
     verdeckt nichts und sitzt über der Kaufleiste. Erst ein Tipp darauf
     öffnet das bekannte Fenster. X an der Leiste = 14 Tage Ruhe wie bisher.
   - LAPTOP: kein Zeitgeber mehr. Das Fenster öffnet, wenn die Maus oben aus
     dem Fenster fährt (Richtung Tab-Leiste/Schließen), frühestens nach
     MIN_SEKUNDEN im Shop und höchstens einmal je Sitzung.
   GEÄNDERT 19.09.2026 (Theme 4.1): Leiste nach 15 statt 8 Sekunden und jetzt
   auf allen Geräten (Laptop: kleine Karte unten links). Weiches Einblenden
   (0,7 s). Das Laptop-Fenster beim Verlassen bleibt – aber nur, solange die
   Leiste noch nicht gezeigt wurde, damit nie beides kommt.
   Alle bisherigen Sperren gelten weiter (angemeldet, 14 Tage nach „Nein
   danke“, Warenkorbseite, Cookie-Banner offen). ?zinke-nl=1 öffnet sofort.

   Die Leiste baut dieses Skript selbst und nimmt ihre Texte aus dem Fenster
   (Titel, Knopf, Schließen) — dadurch ist sie in allen acht Sprachen
   übersetzt, ohne dass das Snippet angefasst werden musste. */
(function () {
  'use strict';

  var wurzel = document.querySelector('[data-zinke-nl]');
  if (!wurzel) return;

  var LEISTE_SEKUNDEN = 15;        // alle Geräte: sichtbare Zeit bis zur Leiste (4.1: 8 → 15 s, Meta-Verweildauer Ø 17 s)
  var MIN_SEKUNDEN = 5;            // Laptop: frühestens dann auf Verlassen reagieren
  var PAUSE_TAGE = 14;             // nach „Nein danke"
  var K_ZEIT = 'zinkeNlSekunden';  // sessionStorage: bisher gesammelte Sekunden
  var K_ZU = 'zinkeNlZuBis';       // localStorage: gesperrt bis (ms)
  var K_DABEI = 'zinkeNlAngemeldet'; // localStorage: angemeldet
  var K_VERLASSEN = 'zinkeNlVerlassen'; // sessionStorage: Laptop-Fenster in dieser Sitzung schon gezeigt

  var vorlage = wurzel.getAttribute('data-template');
  var karte = wurzel.querySelector('.zinke-nl__karte');
  var form = wurzel.querySelector('form');
  var feld = wurzel.querySelector('#ZinkeNlEmail');
  var senden = wurzel.querySelector('[data-zinke-nl-senden]');
  var fehler = wurzel.querySelector('[data-zinke-nl-fehler]');
  var schrittAnmelden = wurzel.querySelector('[data-zinke-nl-schritt="anmelden"]');
  var schrittDank = wurzel.querySelector('[data-zinke-nl-schritt="dank"]');
  var zuletztFokus = null;
  var offen = false;
  var leiste = null;

  function lesen(speicher, k) { try { return window[speicher].getItem(k); } catch (e) { return null; } }
  function schreiben(speicher, k, v) { try { window[speicher].setItem(k, v); } catch (e) {} }
  function handy() { return window.matchMedia('(max-width: 749px)').matches; }

  var erzwingen = /[?&]zinke-nl=1\b/.test(location.search);
  var erfolgNachReload = !!wurzel.querySelector('[data-zinke-nl-erfolg]');
  var fehlerNachReload = !!wurzel.querySelector('[data-zinke-nl-fehlerhaft]');

  function gesperrt() {
    if (erzwingen) return false;
    if (lesen('localStorage', K_DABEI) === '1') return true;
    var bis = parseInt(lesen('localStorage', K_ZU) || '0', 10);
    return bis > Date.now();
  }

  function pauseSetzen() {
    if (lesen('localStorage', K_DABEI) !== '1') {
      schreiben('localStorage', K_ZU, String(Date.now() + PAUSE_TAGE * 864e5));
    }
  }

  function cookieBannerOffen() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var s = window.getComputedStyle(b);
    return s.display !== 'none' && s.visibility !== 'hidden' && b.offsetHeight > 0;
  }

  /* ---------- Öffnen / Schließen ---------- */
  function oeffnen() {
    if (offen) return;
    offen = true;
    leisteWeg();
    zuletztFokus = document.activeElement;
    wurzel.hidden = false;
    document.documentElement.classList.add('zinke-nl-gesperrt');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { wurzel.classList.add('is-offen'); });
    });
    setTimeout(function () {
      var ziel = schrittDank.hidden ? feld : schrittDank.querySelector('.zinke-nl__knopf');
      // Auf dem Handy nicht sofort die Tastatur aufreißen
      if (handy() && ziel === feld) { karte.focus({ preventScroll: true }); }
      else if (ziel) { ziel.focus({ preventScroll: true }); }
    }, 350);
    document.addEventListener('keydown', tasten);
  }

  function schliessen() {
    if (!offen) return;
    offen = false;
    wurzel.classList.remove('is-offen');
    document.removeEventListener('keydown', tasten);
    pauseSetzen();
    setTimeout(function () {
      wurzel.hidden = true;
      document.documentElement.classList.remove('zinke-nl-gesperrt');
      if (zuletztFokus && zuletztFokus.focus) zuletztFokus.focus({ preventScroll: true });
    }, 450);
  }

  function tasten(e) {
    if (e.key === 'Escape') { e.preventDefault(); schliessen(); return; }
    if (e.key !== 'Tab') return;
    var teile = Array.prototype.filter.call(
      karte.querySelectorAll('a[href],button,input:not([type=hidden])'),
      function (el) { return el.offsetParent !== null && !el.disabled; }
    );
    if (!teile.length) return;
    var erstes = teile[0], letztes = teile[teile.length - 1];
    if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
    else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
  }

  Array.prototype.forEach.call(wurzel.querySelectorAll('[data-zinke-nl-zu]'), function (el) {
    el.addEventListener('click', schliessen);
  });

  /* ---------- Leiste (Handy und seit 4.1 auch Laptop) ---------- */
  var LEISTE_CSS =
    '.zinke-nl-leiste{position:fixed;left:.75rem;right:4.6rem;z-index:54;' + /* rechts Platz fuer die Chat-Blase */
    'bottom:calc(var(--zinke-kaufleiste, 0px) + .6rem + env(safe-area-inset-bottom,0px));' +
    'display:flex;align-items:stretch;background:var(--paper,#111);color:var(--ink,#f5f3ed);' +
    'border:1px solid var(--accent,#a8763e);box-shadow:0 8px 24px #0008;' +
    'transform:translateY(calc(100% + 2rem));opacity:0;transition:transform .7s cubic-bezier(.2,.7,.3,1),opacity .7s ease,bottom .3s}' +
    '.zinke-nl-leiste.is-offen{transform:none;opacity:1}' +
    '.zinke-nl-leiste__auf{flex:1 1 auto;min-width:0;min-height:48px;padding:.55rem .85rem;background:none;border:0;color:inherit;' +
    'font:inherit;font-size:.8125rem;line-height:1.35;text-align:left;cursor:pointer}' +
    '.zinke-nl-leiste__auf strong{font-weight:500;color:var(--accent,#a8763e)}' +
    '.zinke-nl-leiste__x{flex:0 0 44px;display:flex;align-items:center;justify-content:center;background:none;border:0;' +
    'border-left:1px solid var(--line,#333);color:inherit;cursor:pointer}' +
    '.zinke-nl-leiste__x svg{width:18px;height:18px}' +
    '@media (min-width:750px){.zinke-nl-leiste{left:1.5rem;right:auto;bottom:1.5rem;max-width:380px}}' +
    '@media (prefers-reduced-motion:reduce){.zinke-nl-leiste{transition:none}}';

  function leisteBauen() {
    if (leiste) return leiste;
    var stil = document.createElement('style');
    stil.textContent = LEISTE_CSS;
    document.head.appendChild(stil);

    var titel = (wurzel.querySelector('#ZinkeNlTitel') || {}).textContent || '';
    var knopfText = senden ? senden.textContent.trim() : '';
    var xText = (wurzel.querySelector('.zinke-nl__x') || { getAttribute: function () { return ''; } }).getAttribute('aria-label');

    leiste = document.createElement('div');
    leiste.className = 'zinke-nl-leiste';
    leiste.setAttribute('role', 'region');
    leiste.setAttribute('aria-label', titel.trim());

    var auf = document.createElement('button');
    auf.type = 'button';
    auf.className = 'zinke-nl-leiste__auf';
    auf.textContent = titel.trim() + ' · ';
    var fett = document.createElement('strong');
    fett.textContent = knopfText;
    auf.appendChild(fett);
    auf.addEventListener('click', oeffnen);

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'zinke-nl-leiste__x';
    x.setAttribute('aria-label', xText || '×');
    x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/></svg>';
    x.addEventListener('click', function () { pauseSetzen(); leisteWeg(); });

    leiste.appendChild(auf);
    leiste.appendChild(x);
    document.body.appendChild(leiste);
    return leiste;
  }

  function leisteZeigen() {
    var l = leisteBauen();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { l.classList.add('is-offen'); });
    });
  }

  function leisteWeg() {
    if (!leiste) return;
    var l = leiste;
    leiste = null;
    l.classList.remove('is-offen');
    setTimeout(function () { l.remove(); }, 400);
  }

  /* ---------- Erfolg ----------
     22.09.: Der Code wird hier NICHT mehr gezeigt und NICHT mehr in den
     Warenkorb gelegt. Der Dankschritt sagt nur, dass die Mail unterwegs ist. */
  function erfolg() {
    schreiben('localStorage', K_DABEI, '1');
    schrittAnmelden.hidden = true;
    schrittDank.hidden = false;
    var knopf = schrittDank.querySelector('.zinke-nl__knopf');
    if (offen && knopf) setTimeout(function () { knopf.focus({ preventScroll: true }); }, 50);
  }

  /* ---------- Absenden ----------
     Bewusst OHNE fetch: Shopify schuetzt Kundenformulare mit hCaptcha, das sich
     an das normale Absenden haengt. Ein fetch-POST bekommt 403 (am 18.09.2026
     gemessen). Also normal absenden; Shopify leitet mit customer_posted=true
     auf dieselbe Seite zurueck, Liquid setzt data-zinke-nl-erfolg und das
     Pop-up oeffnet dort direkt im Dankschritt. */
  var T_FEHLER = wurzel.getAttribute('data-t-fehler') || '';
  var T_WEGWERF = wurzel.getAttribute('data-t-wegwerf') || T_FEHLER;
  var T_CAPTCHA = wurzel.getAttribute('data-t-captcha') || T_FEHLER;

  // Bekannte Wegwerf-Dienste. Kurz gehalten: die geläufigsten, mehr bringt nichts,
  // weil täglich neue entstehen.
  var WEGWERF = ['mailinator.com','yopmail.com','yopmail.fr','trashmail.com','trashmail.de','10minutemail.com','10minutemail.de','guerrillamail.com','guerrillamail.de','sharklasers.com','temp-mail.org','tempmail.com','tempmailo.com','throwawaymail.com','getnada.com','dispostable.com','fakeinbox.com','maildrop.cc','mailnesia.com','spamgourmet.com','wegwerfemail.de','byom.de','muellmail.com','einrot.com','tempr.email','emailondeck.com','moakt.com','mohmal.com','luxusmail.org','inboxkitten.com','mail.tm','1secmail.com','minuteinbox.com','discard.email','tempmail.net','mailsac.com','trashmail.net','spam4.me'];

  // 22.09.: Beispiel- und Testdomains. example.* ist nach RFC 2606 reserviert und
  // kann überhaupt keine Mail annehmen — eine Anmeldung damit ist immer Unsinn.
  var BEISPIEL = ['example.com','example.org','example.net','example.edu','example.de','beispiel.de','beispiel.com','test.de','test.com','testmail.de','muster.de','mustermann.de','musterfirma.de','domain.com','asdf.de','asdf.com','aaa.de','abc.de','xxx.de'];

  // TLDs, die es im offenen Netz nicht gibt (RFC 2606 / RFC 6761).
  var BEISPIEL_TLD = ['test','invalid','local','localhost','example','internal','lan'];

  // Offensichtliche Fantasienamen vor dem @.
  var FANTASIE = /^(max[._-]?mustermann|erika[._-]?mustermann|mustermann|maxmuster|john[._-]?doe|jane[._-]?doe|test\d*|testtest|test[._-]?mail|asdf+|qwert\w*|abcdef?|aaa+|xxx+|fake|dummy|kein[._-]?name|nobody|niemand)$/;

  // Häufige Vertipper bei großen Anbietern
  var TIPPFEHLER = {'gmial.com':'gmail.com','gmai.com':'gmail.com','gmail.co':'gmail.com','gmail.con':'gmail.com','gmaill.com':'gmail.com','gamil.com':'gmail.com','gmx.d':'gmx.de','gmx.de.':'gmx.de','web.d':'web.de','webb.de':'web.de','hotmai.com':'hotmail.com','hotmial.com':'hotmail.com','outlok.com':'outlook.com','yaho.de':'yahoo.de','t-onlin.de':'t-online.de','icloud.de':'icloud.com'};

  function zeigeFehler(text) {
    fehler.textContent = text;
    fehler.hidden = false;
    senden.removeAttribute('aria-busy');
  }

  function adressePruefen(wert) {
    var v = (wert || '').trim();
    if (v.length < 6 || v.length > 254) return T_FEHLER;
    if (!/^[^\s@,;:<>()\[\]\\"]+@[^\s@.]+(\.[^\s@.]+)+$/.test(v)) return T_FEHLER;
    if (/\.\./.test(v)) return T_FEHLER;
    var teile = v.toLowerCase().split('@');
    var lokal = teile[0], domain = teile[1];
    var tld = domain.split('.').pop();
    if (tld.length < 2 || /[^a-z]/.test(tld)) return T_FEHLER;
    if (lokal.length < 2) return T_FEHLER;
    if (BEISPIEL_TLD.indexOf(tld) > -1) return T_WEGWERF;
    if (BEISPIEL.indexOf(domain) > -1) return T_WEGWERF;
    if (/^example\./.test(domain)) return T_WEGWERF;
    if (WEGWERF.indexOf(domain) > -1) return T_WEGWERF;
    if (FANTASIE.test(lokal)) return T_WEGWERF;
    if (TIPPFEHLER[domain]) return T_FEHLER + ' ' + (T_FEHLER.indexOf('?') > -1 ? '' : '→ ') + lokal + '@' + TIPPFEHLER[domain];
    return '';
  }

  var wartet = null;

  form.addEventListener('submit', function (e) {
    fehler.hidden = true;
    var meldung = adressePruefen(feld.value);
    if (meldung) {
      e.preventDefault();
      zeigeFehler(meldung);
      feld.focus();
      return;
    }
    senden.setAttribute('aria-busy', 'true');
    // Wenn die Seite nach 12 s immer noch hier steht, hat Shopifys Spam-Schutz
    // die Anmeldung still abgewiesen. Dann wenigstens sagen, was zu tun ist.
    if (wartet) clearTimeout(wartet);
    wartet = setTimeout(function () { zeigeFehler(T_CAPTCHA); }, 12000);
  });

  feld.addEventListener('input', function () { fehler.hidden = true; });

  /* ---------- Start ---------- */
  if (erfolgNachReload) {
    erfolg();
    oeffnen();
    return;
  }
  if (fehlerNachReload) { fehler.hidden = false; oeffnen(); return; }
  if (erzwingen) { oeffnen(); return; }
  if (gesperrt()) return;

  var gesammelt = parseInt(lesen('sessionStorage', K_ZEIT) || '0', 10) || 0;
  var fertig = false;

  function bereit() {
    return !(vorlage === 'cart' || cookieBannerOffen() || gesperrt());
  }

  // Sekundenuhr: zählt nur sichtbare Zeit; auf dem Handy löst sie die Leiste aus.
  var uhr = setInterval(function () {
    if (document.visibilityState !== 'visible') return;
    gesammelt += 1;
    schreiben('sessionStorage', K_ZEIT, String(gesammelt));
    if (fertig) { clearInterval(uhr); return; }
    if (gesammelt < LEISTE_SEKUNDEN) return;
    if (!bereit()) return; // später erneut prüfen
    fertig = true;
    clearInterval(uhr);
    leisteZeigen();
  }, 1000);

  // Laptop: Maus verlässt das Fenster nach oben.
  document.addEventListener('mouseout', function (e) {
    if (fertig || offen || handy()) return;
    if (e.relatedTarget || e.clientY > 0) return;
    if (gesammelt < MIN_SEKUNDEN) return;
    if (lesen('sessionStorage', K_VERLASSEN) === '1') return;
    if (!bereit()) return;
    fertig = true;
    schreiben('sessionStorage', K_VERLASSEN, '1');
    oeffnen();
  });
})();
